import React, { useState,useRef, useEffect } from "react";

// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import makeStyles from "@material-ui/core/styles/makeStyles";
import styles from "assets/jss/material-kit-react/components/answersList.js";
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Config from "../../config.js"
import Axios from "axios";
import swal from 'sweetalert'
import jalaali from 'jalaali-js'



const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    }
  },
  bg:{
      '& > *': {
      borderBottom: 'unset',
      },
      backgroundColor:"#eeeeee"
  }
});
function roundToTwo(num) {    
    return +(Math.round(num + "e+2")  + "e-2");
}
function getStatus(row){
  switch (row.resMessage) {
    case 'In Queue':
    return ("در صف اجرا");
    case 'Processing':
    return ("در حال اجرا");
    case 'Accepted':
    return ("اجرای موفق");
    case 'Wrong Answer':
    return ("پاسخ نادرست");
    case 'Time Limit Exceeded':
    return ("خطای محدودیت زمان");
    case 'Compilation Error':
    return ("خطای کمپایل");
    case 'Runtime Error (SIGSEGV)':
    return ("خطای زمان اجرا (SIGSEGV)");
    case 'Runtime Error (SIGXFSZ)':
    return ("خطای زمان اجرا (SIGXFSZ)");
    case 'Runtime Error (SIGFPE)':
    return ("خطای زمان اجرا (SIGFPE)");
    case 'Runtime Error (SIGABRT)':
    return ("خطای زمان اجرا (SIGABRT)");
    case 'Runtime Error (NZEC)':
    return ("خطای زمان اجرا (NZEC)");
    case 'Runtime Error (Other)':
    return ("خطای زمان اجرا");
    case 'Internal Error':
    return ("خطای داخلی");
    case 'Exec Format Error':
    return ("خطای فرمت اجرا");
    default:
    return ("نامعلوم");
}
}
function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.languageId&&Config.languages[row.languageId].title}
        </TableCell>
        <TableCell align="right">{(()=>{
var date = new Date(row.createdAt)
var j= jalaali.toJalaali(date.getFullYear(),date.getMonth(),date.getDate())
  return (j.jy+"/"+j.jm+"/"+j.jd)
          
})()}</TableCell>
<TableCell align="right">{(()=>{
var date = new Date(row.createdAt)
  return (date.getHours()+":"+date.getMinutes()+":"+date.getSeconds())
          
})()}</TableCell>
        <TableCell align="right">
        {(() => {
                      switch (row.status) {
                              case 0:
                              return ("جدید");
                              case 1:
                              return ("در حال اجرا");
                              case 2:
                              return ("پاسخ نادرست");
                              case 3:
                              return ("پاسخ صحیح");
                              case -1:
                              return ("خطا در اجرا");
                              default:
                              return ("نامعلوم");
                      }
})()}
</TableCell>
      </TableRow>
      <TableRow >
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                اجراها
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>حافظه استفاده شده</TableCell>
                    <TableCell>زمان اجرا</TableCell>
                    <TableCell>اجرا</TableCell>
                    <TableCell>متن خطا</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody >
                  {row.run.map((historyRow) => 
                    ((historyRow.memory||historyRow.compileOutput))?
                    (
                    <TableRow key={historyRow._id}  className={classes.bg}>
                      <TableCell component="th" scope="row">
                        {historyRow.memory&&(roundToTwo(historyRow.memory/1024) + " کیلوبایت")}
                      </TableCell>
                      <TableCell>{historyRow.time&&(historyRow.time+ " ثانیه")}</TableCell>
                      <TableCell>{historyRow.status?((!historyRow.compileOutput)?getStatus(historyRow):"خطای کامپایل"):"خطای ارسال"}</TableCell>
                      <TableCell className={classes.LeftToRight} >{historyRow.compileOutput?historyRow.compileOutput:historyRow.resOutput}</TableCell>
                    </TableRow>
                    )
                    :(null)
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}






const AnswersList = React.forwardRef((props, ref) => {
    const {
        questionId,
        challengeId,
        refresh,
        ...rest
    } = props;
    const useStyles = makeStyles();
    useEffect(() => {
        if(refresh){
        GetData(challengeId,questionId);
        }
    },[refresh]);
    const [answers, setAnswers] = React.useState(null);

    const GetData = (cid, qid) => {
        Axios.post(Config.api + "Challenge/GetResult", {
            questionId: qid,
            challengeId: cid,
            onlySuccess:false
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                setAnswers(result.data.data)
            }).catch((err) => {
                if (err&&err.response&&err.response.status&&err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err&&err.response&&err.response.status&&err.response.status === 422)
                    swal("اطلاعات ارسالی نادرست است.");
                else if (err&&err.response&&err.response.data&&err.response.data.message&&err.response.data.message.pr) {
                    swal(err.response.data.message.pr);
                }
                else swal("خطایی رخ داده است.")
            })
    }
    
      const classes = useStyles();
      return (
           <TableContainer className={classes.root}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>زبان برنامه نویسی</TableCell>
                <TableCell align="right">تاریخ ارسال</TableCell>
                <TableCell align="right">ساعت ارسال</TableCell>
                <TableCell align="right">وضعیت</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {answers && answers.map((row) => (
            <Row key={row.createdAt} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
      );
});


export default AnswersList;
